export class SplatLoaderService {
  private static instance: SplatLoaderService;
  private editor: any = null;
  private pendingLoad: string | null = null;

  private constructor() {}

  static getInstance(): SplatLoaderService {
    if (!SplatLoaderService.instance) {
      SplatLoaderService.instance = new SplatLoaderService();
    }
    return SplatLoaderService.instance;
  }

  setEditor(editor: any) {
    this.editor = editor;
    console.log('[SplatLoaderService] Editor registered');
    if (this.pendingLoad) {
      console.log('[SplatLoaderService] Processing pending load:', this.pendingLoad);
      this.load(this.pendingLoad);
      this.pendingLoad = null;
    }
  }

  async load(url: string): Promise<void> {
    if (!this.editor) {
      console.warn('[SplatLoaderService] Editor not ready, queuing load:', url);
      this.pendingLoad = url;
      // We resolve here to not block the machine, but ideally we'd wait.
      // However, for the machine to transition to 'idle', the load must complete.
      // If we return a promise that waits for the editor, the machine will stay in 'loading'.
      return this.waitForEditorAndLoad(url);
    }

    console.log('[SplatLoaderService] Loading URL:', url);
    // Use the custom event we added to file-handler.ts
    return this.editor.events.invoke('scene.loadUrl', url);
  }

  private async waitForEditorAndLoad(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const check = () => {
        if (this.editor) {
          this.load(url).then(resolve).catch(reject);
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  }
}

export const splatLoaderService = SplatLoaderService.getInstance();
